export default __webpack_public_path__ + "static/media/friendship1.9632229b.jpg";